// absenceDayExport.js
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formatPositionsDisplay } from '../services/positionAPIs';


export const exportDayAbsencesToPDF = (selectedDate, dayAbsences) => {
  // Create new PDF document
  const doc = new jsPDF();
  
  // Format date for title
  const formattedDate = selectedDate.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  
  // Add title
  doc.setFontSize(16);
  doc.text(`Absence Report - ${formattedDate}`, 14, 15);
  
  // Add summary section
  doc.setFontSize(12);
  doc.text('Summary', 14, 30);
  
  // Calculate summary statistics
  const totalEmployees = dayAbsences.length;
  const partialDays = dayAbsences.filter(abs => 
    abs.type === 'LATENESS' || abs.type === 'PARTIAL_DAY'
  ).length;
  const fullDays = dayAbsences.filter(abs => 
    abs.type !== 'LATENESS' && abs.type !== 'PARTIAL_DAY'
  ).length;
  
  // Add summary table
  autoTable(doc,{
    startY: 35,
    head: [['Metric', 'Count']],
    body: [
      ['Total Employees', totalEmployees],
      ['Partial Days', partialDays],
      ['Full Days', fullDays]
    ],
    theme: 'grid',
    headStyles: { fillColor: [66, 139, 202] },
  });
  
  // Add employee details section if there are absences
  if (dayAbsences.length > 0) {
    doc.setFontSize(12);
    doc.text('Employee Details', 14, doc.lastAutoTable.finalY + 15);
    
    // Prepare data for employee details table
    const tableData = dayAbsences.map(absence => {
      const absenceTypeLabels = {
        LATENESS: 'Lateness',
        PARTIAL_DAY: 'Partial Day',
        FULL_DAY: 'Full Day',
        MULTIPLE_DAYS: 'Multiple Days'
      };
      
      // Calculate duration
      let duration = '';
      if (absence.hours) {
        duration = `${absence.hours} hour(s)`;
      } else if (absence.type === 'PARTIAL_DAY') {
        duration = '4 hours';
      } else {
        duration = calculateDuration(
          absence.date, 
          absence.endDate, 
          absence.startTime, 
          absence.endTime
        );
      }
      
      return [
        `${absence.employee.firstName} ${absence.employee.lastName}`,
        formatPositionsDisplay(absence.employee),
        absence.employee.department?.name || 'N/A',
        absenceTypeLabels[absence.type] || absence.type,
        duration,
        absence.reason || 'N/A'
      ];
    });
    
    // Add employee details table
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 20,
      head: [['Name', 'Position', 'Department', 'Type', 'Duration', 'Reason']],
      body: tableData,
      theme: 'grid',
      headStyles: { fillColor: [66, 139, 202] },
      styles: { fontSize: 9 },
      columnStyles: {
        0: { cellWidth: 25 },
        1: { cellWidth: 25 },
        2: { cellWidth: 25 },
        3: { cellWidth: 20 },
        4: { cellWidth: 20 },
        5: { cellWidth: 45 }
      }
    });
  }
  
  // Save the PDF
  doc.save(`absence-report-${selectedDate.toISOString().split('T')[0]}.pdf`);
};

// Helper function to calculate duration
const calculateDuration = (startDate, endDate, startTime, endTime) => {
  const start = new Date(startDate);
  const end = new Date(endDate || startDate);
  const daysDiff = Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;
  
  if (daysDiff === 1 && startTime && endTime) {
    const startHour = parseInt(startTime.split(':')[0]);
    const endHour = parseInt(endTime.split(':')[0]);
    const hours = endHour - startHour;
    return `${hours} hour(s)`;
  }
  
  return daysDiff === 1 ? 'Full Day' : `${daysDiff} days`;
};